import {SET_ELEMENT, LICENSE_FIX, SET_COPYRIGHT_LICENSE, COPYRIGHT_LICENSE_SHOW_MODAL, SET_PERFORMED_MULTI_LICENSE_EXCLUSION} from '../constants/constants'


export const setElementToExclude = (reason, newMitigation,isGlobalExclusionAvailable=false, isMultiple=false) =>{
    if(!isMultiple) {
        newMitigation.content.reason=reason;
        if(newMitigation.domain==="licenses") newMitigation.title=`${(newMitigation.reason==="mitigated")?"Excluding":"Reporting"} ${newMitigation.title}:`
        if(newMitigation.domain.includes("security") && !newMitigation.title.includes(reason)) newMitigation.title+=" "+reason;
        if(newMitigation.domain==="stability") newMitigation.title+=" "+newMitigation.content.library.name;   
    } else {
        newMitigation.title = "Excluding multiple libraries"
    }


    window.$("#exclude-dialog").modal('toggle')

    return {
        type: SET_ELEMENT,
        payload:{
            action: "add",
            element: newMitigation,
            isGlobalExclusionAvailable,
            isMultiple
        }
    }
}

export const setExclusionToRemove = (advice,isGlobalExclusionAvailable=false)=>{
    const {uuid,library,report,cve,version,language,domain,choices}=advice;
    const text="Are you sure you want to remove the mitigation for the library "+library+"?";

    window.$('#confirm').modal({backdrop: 'static'})

    return {
        type: SET_ELEMENT,
        payload:{
            action: "remove",
            element:{
                text,uuid,report,cve,version,language,domain,library,choices
            },
            isGlobalExclusionAvailable
        }
    }
}

export const setLicenseToFix = (library)=>{
    if(!library) {
        return{ 
            type: LICENSE_FIX,
            payload: {}
        }
    }
    library=library.content;
    const title="License for library "+library.library.name+" (version "+library.version+")";
    window.$('#licenses-add-dropdown').empty();
    window.$('#licenses-add-dropdown').selectpicker('refresh');
    window.$('#license-fix-dialog').modal({backdrop: 'static'})
    return{ 
        type: LICENSE_FIX,
        payload: {...library, title}
    };
}

export const setCopyrightLicense = (library) => {
    window.$('#licenses-add-dropdown').empty();
    window.$('#licenses-add-dropdown').selectpicker('refresh');
    window.$('#license-copyright-modal').modal({backdrop: 'static'})
    return {
        type: SET_COPYRIGHT_LICENSE,
        payload: {library}
    }
}

export const setPerformedMultiLicenseExclusion = (value) => {
    return {
        type: SET_PERFORMED_MULTI_LICENSE_EXCLUSION,
        payload: {value}
    }
}